import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { User, CreateUserRequest, ChangePasswordRequest } from '../types';

export const userService = {
  getAll: async (): Promise<User[]> => {
    const response = await apiClient.get<User[]>(API_ENDPOINTS.USERS.BASE);
    return response.data;
  },

  getById: async (id: number): Promise<User> => {
    const response = await apiClient.get<User>(API_ENDPOINTS.USERS.BY_ID(id));
    return response.data;
  },

  create: async (data: CreateUserRequest): Promise<User> => {
    const response = await apiClient.post<User>(API_ENDPOINTS.USERS.BASE, data);
    return response.data;
  },

  update: async (id: number, data: Partial<CreateUserRequest>): Promise<User> => {
    const response = await apiClient.put<User>(API_ENDPOINTS.USERS.BY_ID(id), data);
    return response.data;
  },

  deactivate: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.USERS.BY_ID(id));
  },

  changePassword: async (data: ChangePasswordRequest): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.put<{ success: boolean; message: string }>(
      API_ENDPOINTS.PROFILE.PASSWORD,
      data
    );
    return response.data;
  },
};
